module.exports = {
    ORDER_STATUS: Object.freeze({
        // Оформление - для предоплаты
        // Ожидает подтверждения - для постоплаты
        SUBMITTED: 1,

        // В работе - для постоплаты (химчистки)
        IN_WORK: 12,

        // Ожидает оплаты - для постоплаты
        PREPARED: 11,

        // Оплачен
        PAID: 2,

        // Подтвержден партнером
        ACCEPTED: 22,
        // Отклонен партнером
        DECLINED: 32,

        // Готовим (рестораны)
        // Чистим (химчистки)
        // Собираем (цветы, магазины, аптеки)
        AWAITING: 3,
        // Приготовлен
        AWAITING_READY: 13,

        // Доставляется курьером
        DELIVERY: 4,
        // Доставляется консьержем
        DELIVERY_CONCIERGE: 14,
        //В точке встречи
        MEETING_POINT: 24,

        // Выполнен
        DONE: 5,
        // Корректировка чека
        PAYMENT_CORRECTION: 15,

        // Отменен
        CANCELED: 6,
    }),
    ORDER_TYPE: Object.freeze({
        RESTAURANT_DELIVERY: 1,
        FLOWERS_DELIVERY: 2,
        LAUNDRY_DELIVERY: 3,
        GROCER_DELIVERY: 4,
        PHARMACY_DELIVERY: 5,
        ASSISTANT_HELP: 6,
        ENTITY_DELIVERY: 7,
    }),
    PASS_TYPE: Object.freeze({
        NOT_PASSED: 1,
        PASSED: 2,
        NOT_NEED: 3,
    }),
    ORDER_LOG_TYPE: Object.freeze({
        CREATED: 1,
        STATUS_UPDATED: 2,
        UPDATED: 3
    }),
    ORDER_PAYMENT_STATUS: Object.freeze({
        PROCESSING: 1,
        SUCCESS: 2,
        FAIL: 3,
        CANCELLED: 4,
        NOT_FOUND: 5
    }),
    DELIVERY_TYPE: Object.freeze({
        DOOR: 1,
        MEETING_POINT: 2,
        WITHOUT: 3,
        COLLECT: 4,
    }),
    BUSINESS_TYPE: Object.freeze({
        RESTAURANT: 'restaurant',
        FLORIST: 'florist',
        LAUNDRY: 'laundry',
        GROCER: 'grocery',
        PHARMACY: 'pharmacy',
        ASSISTANT: 'assistant',
        ENTITY: 'entity'
    }),
    STATUS_DIALOGS_TYPES: Object.freeze({ 
        NOT_PAID: 1, // Не оплачен
        AWAITING: 2, // Собираем , готовим
        DELIVERY: 3, // В доставке,
        DONE: 4, // Выполнен,
        CANCELED: 5, // Отменен
        AWAITING_READY: 6, // готов к выдаче (в ресторане, в магазине, в точке встречи)
        MEETING_POINT: 7, // в точке встречи
        IN_WORK: 8, // в работе
        NOT_PAID_POST: 9, // не оплачен (постоплата)
        COOKING: 10, // готовим
        COMPLETED: 11, // уже у вас
        DELIVERED_DOOR: 12 // доставлен до двери
    })
}
